// ══════════════════════════════════════════════════
// MARK: Setup
// ──────────────────────────────────────────────────
import { upperCaseFirst } from '../../module/format.js';


// ══════════════════════════════════════════════════
// MARK: Types
// ──────────────────────────────────────────────────


// ══════════════════════════════════════════════════
// MARK: Events
// ──────────────────────────────────────────────────
export class ScrollEvent extends Event {
	// #═#═#═#═#═# Properties #═#═#═#═#═#
		// #════ Uninitialized ════#
	detail: any;

	
	// #═#═#═#═#═# Constructor #═#═#═#═#═#
	constructor(type: string, detail: any) {
		// #════ Parent ════#
		super(type, {
			bubbles: false,
			composed: true
		});


		// #════ Properties ════#
		this.detail = detail;
	}
}

export class ScrollDirectionChangedEvent extends ScrollEvent {
	constructor(detail: any) {
		super('scrollDirectionChanged', detail);
	}
}


export class ScrollStartEvent extends Event {
	constructor(detail: any) {
		super('scrollStart', detail);
	}
}

export class ScrollEndEvent extends Event {
	constructor(detail: any) {
		super('scrollEnd', detail);
	}
}

export class ScrollAbortEvent extends Event {
	constructor(detail: any) {
		super('scrollAbort', detail);
	}
}

export class ScrollToEvent extends Event {
	constructor(detail: any) {
		super('scrollTo', detail);
	}
}


// ══════════════════════════════════════════════════
// MARK: Bundled Export
// ──────────────────────────────────────────────────
export namespace Events {
    export type Any = ScrollDirectionChangedEvent | ScrollStartEvent | ScrollEndEvent | ScrollAbortEvent | ScrollToEvent;
    
    export const ScrollDirectionChanged = ScrollDirectionChangedEvent;
    export const ScrollStart = ScrollStartEvent;
    export const ScrollEnd = ScrollEndEvent;
    export const ScrollAbort = ScrollAbortEvent;
    export const ScrollTo = ScrollToEvent;
    
    export const Type = (type: string) => {
        const constructor = upperCaseFirst(type) as 'ScrollDirectionChanged' | 'ScrollStart' | 'ScrollEnd' | 'ScrollAbort' | 'ScrollTo';
        return Events[constructor];
    };
}
